<template>
    <div class="wrapper">
        <div class="tit">
            <h1>Pedidos</h1>
        </div>
        <div class="ctn_general">
            <div class="tabla_ctn">
                <div class="tabla_filtros">
                    <Filters :data="filterData" label="Filtrar pedidos" @onFilter="onFilter"/>
                    <div class="tfiltros_col right mOrder1 nowrap">
                        <a @click="reload" class="btn_icon mdi mdi-reload tool">
                            <span class="tooltip bottom left">Actualizar</span>
                        </a>
                        <a @click="downloadExcel" href="javascript:void(0)"
                           class="btn_icon mdi mdi-arrow-collapse-down tool">
                            <span class="tooltip bottom left">Descargar Excel</span>
                        </a>
                        <div class="mdi mdi-magnify input_search">
                            <form @submit.prevent="search">
                                <input type="search" placeholder="Buscar por nombre de cliente o número de pedido"
                                       v-model="keyword">
                            </form>
                        </div>
                    </div>
                </div>
                <div class="tabla_scroll">
                    <table class="lPedidos">
                        <thead>
                        <tr>
                            <th>ID Pedido</th>
                            <th>Fecha y hora de pedido</th>
                            <th>Fecha de entrega</th>
                            <th>Cliente</th>
                            <th>Importe</th>
                            <th>Método de pago</th>
                            <th>Confirmó dirección</th>
                            <th>ERP Id</th>
                            <th>Estado</th>
                            <th>Detalles</th>
                            <th class="d_option"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="o in orders">
                            <td style="text-align: center;">{{o.id}}</td>
                            <td style="text-align: center;" v-date-hour="o.createdAt"></td>
                            <td style="text-align: center;" v-date-local="o.deliveryTime"></td>
                            <td>{{o.clientFullName}}</td>
                            <td v-pen="o.total"></td>
                            <td style="text-align: center;">{{getPaymentMethodStr(o.paymentMethod).value}}</td>
                            <td style="text-align: center;">{{getBooleanStr(o.deliveryPinAddress)}}</td>
                            <td style="text-align: center;">{{o.clientErpId}}</td>
                            <td style="text-align: center;"><span :class="`budget ${getStatusStr(o.status).color}`">{{getStatusStr(o.status).value}}</span>
                            </td>
                            <td style="text-align: center;"><a class="abrir_detalle" @click="selectOrder(o)"><i
                                class="mdi mdi-format-list-bulleted"></i></a></td>
                            <td class="d_option">
                                <i class="mdi mdi-dots-vertical"></i>
                                <span class="drop_options estados_pedido" v-if=" getStatuses(o.status).length > 0">
									<span v-for="s in getStatuses(o.status)"
                                          @click="changeStatus(o, s)">{{s.action}}</span>
								</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <Paginator :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
                           :changePageSize="changePageSize"/>
            </div>
        </div>
        <OrderDetail :order-in="selectedOrder" @updated="onUpdated"/>
    </div>
</template>
<script>

    import OrderService from "../../services/OrderService";
    import {orderStatuses, paymentMethods} from '../../util/options'
    import {getFileName, loading} from '../../util/util'
    import OrderDetail from './OrderDetail.vue';
    import fileDownload from 'js-file-download';
    import Paginator from '../common/Paginator.vue'
    import Filters from '../common/Filters.vue'
    import {paginatorMixin} from '../../util/paginatorMixin'
    import alert from '../../util/alert'

    export default {
        components: {OrderDetail, Paginator, Filters},
        data() {
            return {
                orders: [],
                selectedOrder: null,
                keyword: null,
                filters: [],
                filterData: [
                    {key: 'status', label: 'Estado', type: 'multiple', items: orderStatuses},
                    {key: 'paymentMethod', label: 'Método de pago', type: 'multiple', items: paymentMethods},
                    {
                        key: 'erpId',
                        label: 'ERP Id',
                        type: 'single',
                        items: [{key: 1, value: 'Sí'}, {key: 0, value: 'No'}]
                    },
                    {key: 'createdAt', label: 'Fecha de pedido', type: 'date'},
                    {key: 'deliveryTime', label: 'Fecha de entrega', type: 'date'},
                ]
            }
        },
        mixins: [paginatorMixin],
        methods: {
            getStatusStr(status) {
                return orderStatuses.find((s) => s.key === status);
            },
            getPaymentMethodStr(payMet) {
                return paymentMethods.find((s) => s.key === payMet);
            },
            selectOrder(order) {
                this.selectedOrder = order;
                $(".modal-order-detail").addClass("active");
            },
            downloadExcel() {
                loading(true);
                const params = {};
                const self = this;
                if (self.keyword)
                    params.keyword = self.keyword;
                if (self.filters && self.filters.length > 0) {
                    self.filters.forEach(it => {
                        let opts;
                        if (it.data instanceof Array) {
                            opts = [];
                            it.data.forEach(o => {
                                opts.push(o.key);
                            })
                        } else if (it.data.startDate || it.data.endDate) {
                            opts = [];
                            if (it.data.startDate)
                                opts.push(it.data.startDate.format('YYYY-MM-DD'));
                            if (it.data.endDate)
                                opts.push(it.data.endDate.format('YYYY-MM-DD'))
                        } else {
                            opts = it.data.key;

                        }
                        params[it.key] = opts;

                    })
                }
                OrderService.downloadExcel(params).then(response => {
                    fileDownload(response.data, getFileName(response));
                }).catch((err) => {
                    console.error(err);
                    alert.error("Error al descargar lista de órdenes");
                }).finally(() => {
                    loading(false);
                });
            },
            changePage(p) {
                const self = this;
                self.page = p;
                self.listOrders(p, self.pageSize)
            },
            changePageSize(pageSize) {
                const self = this;
                this.page = 1;
                this.pageSize = pageSize;
                self.listOrders(1, pageSize)
            },
            async listOrders(page, pageSize) {
                try {
                    loading(true);
                    const self = this;
                    const params = {page: page - 1., size: pageSize};
                    if (self.keyword)
                        params.keyword = self.keyword;

                    if (self.filters && self.filters.length > 0) {
                        self.filters.forEach(it => {
                            let opts;
                            if (it.data instanceof Array) {
                                opts = [];
                                it.data.forEach(o => {
                                    opts.push(o.key);
                                })
                            } else if (it.data.startDate || it.data.endDate) {
                                opts = [];
                                if (it.data.startDate)
                                    opts.push(it.data.startDate.format('YYYY-MM-DD'));
                                if (it.data.endDate)
                                    opts.push(it.data.endDate.format('YYYY-MM-DD'))
                            } else {
                                opts = it.data.key;

                            }
                            params[it.key] = opts;

                        })
                    }
                    const resp = (await OrderService.list(params)).data.payload;
                    self.orders = resp.content;
                    self.total = resp.totalElements;
                    self.pages = resp.totalPages;
                } catch (err) {
                    alert.error(err);
                } finally {
                    loading(false);
                }
            },
            search() {
                const self = this;
                self.page = 1;
                self.listOrders(self.page, self.pageSize);
            },
            reload() {
                const self = this;
                self.listOrders(self.page, self.pageSize);
            },
            getStatuses(status) {
                const statuses = [];
                orderStatuses.forEach((s) => {
                    if (s.key > status && !s.hidden) {
                        statuses.push(s);
                    }
                });
                return statuses;
            },
            changeStatus(orderIn, status) {
                const self = this;
                alert.dialog(`¿Desea ${status.action} el pedido # ${orderIn.id}?`,
                    null,
                    async function () {
                        try {
                            loading(true);
                            const resp = (await OrderService.update(orderIn.id, {status: status.key})).data.payload;
                            const order = self.orders.find((o) => {
                                return o.id === resp.id;
                            });
                            if (order) {
                                const index = self.orders.indexOf(order);
                                self.$set(self.orders, index, resp);
                            }
                            alert.success("Pedido actualizado correctamente.");
                        } catch (e) {
                            console.error(e);
                            alert.error("Error actualizando estado de pedido")
                        } finally {
                            loading(false);
                        }
                    });
            },
            onUpdated(resp) {
                const self = this;
                this.selectedOrder = resp;
                const order = self.orders.find((o) => {
                    return o.id === resp.id;
                });
                if (order) {
                    const index = self.orders.indexOf(order);
                    self.$set(self.orders, index, resp);
                }
            },
            onFilter(data) {
                const self = this;
                self.filters = data;
                self.page = 1;
                self.listOrders(self.page, self.pageSize);

            },
            getBooleanStr(val) {
                return val ? 'Sí' : 'No';
            }
        },
        async mounted() {
            this.listOrders(this.page, this.pageSize);

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/orders/Orders.vue